import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DateUtilitiesService } from '../../utilities/date-utilities.service';

dayjs.extend(relativeTime, {
  thresholds: [
    { l: 's', r: 44, d: 'second' },
    { l: 'm', r: 89 },
    { l: 'mm', r: 59, d: 'minute' },
    { l: 'h', r: 89 },
    { l: 'hh', r: 23, d: 'hour' },
    { l: 'd', r: 35 },
    { l: 'dd', r: 29, d: 'day' },
    { l: 'M', r: 1 },
    { l: 'MM', r: 11, d: 'month' },
    { l: 'y', r: 1 },
    { l: 'yy', d: 'year' },
  ],
});

@Pipe({
  name: 'relativeTime',
  standalone: true,
})
export class RelativeTimePipe implements PipeTransform {
  public transform(value: string | undefined, language: string): string | undefined {
    if (!value) {
      return value;
    }

    dayjs.locale(language);

    const date: dayjs.Dayjs = dayjs(value);
    const now: dayjs.Dayjs = dayjs();
    const diffMonths = now.diff(date, 'month');

    if (diffMonths >= 1) {
      return DateUtilitiesService.convertUTCToUserFormatted(value, true);
    } else {
      return date.locale(language).fromNow();
    }
  }
}
